import script from "./user-area.vue?vue&type=script&setup=true&lang=js"
export * from "./user-area.vue?vue&type=script&setup=true&lang=js"

import "./user-area.vue?vue&type=style&index=0&id=733e680a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-733e680a"]])

export default __exports__